import GridModel from './gridmodel';
import DeptLocsCollection from '../collection/deptlocscollection';

const DepartmentModel = GridModel.extend({
  idAttribute: 'departmentID',
  initialize() {
    const deptLocations = this.get('departmentLocations').length > 0 ? this.get('departmentLocations') : [];
    GridModel.prototype.initialize.call(this);
    this.set('departmentLocations', new DeptLocsCollection(deptLocations));
  },
  submitForm(data) {
    const promise = $.Deferred();
    this.save(data, {
      success: (model, response, options) => {
        promise.resolve(model, response, options);
      },
      error: (model, response, options) => {
        promise.reject(model, response, options);
      },
      wait: true
    });
    return promise;
  }
});

export default DepartmentModel;
